import { PartialType } from '../../../utils';
import { CreateDispatchAreaDto } from './create-dispatch-area.dto';
export class UpdateDispatchAreaDto extends PartialType(CreateDispatchAreaDto) {
}
